import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import reliabilityIcon from '../../../../assets/images/technology/rsp/ic1.svg';
import securityIcon from '../../../../assets/images/technology/rsp/ic2.svg';
import performanceIcon from '../../../../assets/images/technology/rsp/ic3.svg';
import './RSP.css';

const items = [
  {
    title: 'Reliability',
    text: 'Uninterrupted access to platforms and services, ensuring your capital is always manageable when you need it most.',
    icon: reliabilityIcon,
  },
  {
    title: 'Security',
    text: 'Institutional-grade encryption and access controls to protect your data and transaction integrity.',
    icon: securityIcon,
  },
  {
    title: 'Performance',
    text: 'Optimized connectivity and execution engines designed for consistent and efficient market interaction.',
    icon: performanceIcon,
  },
];

const RSP = () => {
  return (
    <section className="technology-rsp">
      <div className="technology-rsp__inner">
        <div className="technology-rsp__grid">
          {items.map(({ title, text, icon }, index) => (
            <Reveal key={title} delay={index * 80}>
              <article className="technology-rsp__item">
                <img
                  className="technology-rsp__icon"
                  src={icon}
                  alt=""
                  aria-hidden="true"
                />
                <h3 className="technology-rsp__title">{title}</h3>
                <p className="technology-rsp__text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RSP;
